module.exports = __webpack_public_path__ + "static/media/edit.b079c388.svg";